import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>TRADE</h1>
          <img src={logo} className="App-logo" alt="logo" />
        <p>
          in Research and Development.
        </p>
      </header>
    </div>
  );
}

export default App;
